import { LocationDto } from '@lib-ui/client';

interface LocationInfo {
  street?: string;
  houseNumber?: string;
  postalCode?: string;
  city?: string;
}

export function getGoogleMapsLink(locationInfo: LocationInfo) {
  const street = locationInfo.street ?? '';
  const houseNumber = locationInfo.houseNumber ?? '';
  const postalCode = locationInfo.postalCode ?? '';
  const city = locationInfo.city ?? '';

  return `https://www.google.de/maps/place/${street}+${houseNumber},${postalCode}+${city}`;
}

export function getGoogleMapsLinkFromAddress(location: LocationDto) {
  const address = `${location.street}+${location.houseNumber},${location.postalCode}+${location.city}`;
  return `https://www.google.de/maps/place/${address}`;
}
